import DefaultDropButton from "../Buttons/DefaultDropButton/DefaultDropButton.js";
import {LuTrash2} from "react-icons/lu";
import React from "react";
import {LabeledTextField} from "../Fields/LabeledTextField.js";
import "./ReplaceFieldWithStaticValueAction.css"
import {Input} from "react-aria-components";
import JsonInput from "../JsonInput/JsonInput.js";

export function ReplaceFieldWithStaticValueAction({
    index,
    fieldNames,
    staticValueTypes,
    selectedFieldName,
    selectedStaticValueType,
    value,
    onFieldChange,
    onValueTypeChange,
    onValueChange,
    onDelete
}: {
    index: number;
    selectedFieldName: string;
    fieldNames: string[];
    value: any;
    staticValueTypes: string[];
    selectedStaticValueType: string;
    onFieldChange: (index: number, newValue: string) => void;
    onValueTypeChange: (index: number, newValue: string) => void;
    onValueChange: (index: number, newValue: string) => void;
    onDelete: (index: number) => void;
}) {
    let extraInput = null;
    if(selectedStaticValueType === "string") {
        extraInput = <LabeledTextField
            placeholder="(Value)"
            name={"value_" + index}
            value={""}
            onChange={(e) => {
                const newValue = e.target.value;
                onValueChange(index, newValue);
            }}
            hiddenLabel={"Value"}
            label={undefined}
            className="static-string"
            errorLoc={[]}
        />
    }
    if(selectedStaticValueType === "json") {
        extraInput = <JsonInput
            jsonData={value === null ? {} : value}
            setJsonData={(newValue) => {
                onValueChange(index, newValue);
            }}
            className="static-json"
            errorLoc={[]}
        />
    }
    return <div className="action ReplaceFieldWithStaticValue" key={index}>
        <div className="row type-selection">
            <div className="firstText">Replace field</div>
            <DefaultDropButton
                name={"action_" + index + "_field"}
                options={fieldNames}
                onSelect={(v) => onFieldChange(index, v)}
                className="action-field"
                selected={selectedFieldName}
                label={"Replace field"}
                hideLabel
                errorLoc={[]}
            />
            <div className="with-static">with static type</div>
            <DefaultDropButton
                name={"action_" + index + "_static_value_type"}
                options={staticValueTypes}
                selected={selectedStaticValueType}
                onSelect={(v) => {
                    onValueTypeChange(index, v)
                    onValueChange(index, null)
                }}
                className="action-field"
                label="static value"
                hideLabel
                errorLoc={[]}
            />
            { selectedStaticValueType === "integer" ? <>
                <Input
                    placeholder="(Value)"
                    name={"value_" + index}
                    value={value}
                    type="number"
                    onChange={(e) => {
                        onValueChange(index, e.target.value);
                    }}
                    className="static-integer"
                />
                </>: <div className="spacer" />}
            <LuTrash2
                className="trash"
                onClick={() => onDelete(index)}
            />
        </div>
        <div className="row extra-input">
            {extraInput}
        </div>
    </div>
}